module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3@2-5fd6dc69db670c369678975ae88bc40b.jpg";